import React, { useState } from 'react';
import { Copy, Check, X, AlertCircle } from 'lucide-react';
import api from '../../api/client';

export default function CopiaCicloModal({ cicloSorgente, onClose, onSuccess }) {
  const tipoSuccessivo = cicloSorgente.tipo === 'Q1' ? 'Q2' : cicloSorgente.tipo;
  const annoSuccessivo = cicloSorgente.anno_inizio;
  const [form, setForm] = useState({
    nome: '',
    tipo: tipoSuccessivo,
    anno_inizio: annoSuccessivo,
    data_inizio: '',
    data_fine: '',
    // Il rinnovo resta nella stagione del ciclo sorgente: chi aveva già la quota non la ripaga
    quota_tesseramento: tipoSuccessivo === 'ESTIVO' ? 15 : (cicloSorgente.quota_tesseramento ?? 25),
    stagione_tesseramento: cicloSorgente.stagione_tesseramento ?? (cicloSorgente.tipo === 'ESTIVO' ? cicloSorgente.anno_inizio - 1 : cicloSorgente.anno_inizio),
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult]   = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post(`/planning/cicli/${cicloSorgente.id}/copia`, form);
      setResult(r.data);
    } catch(err) {
      alert(err.response?.data?.error || err.message);
    } finally { setLoading(false); }
  };

  if (result) return (
    <div style={s.overlay}>
      <div style={s.modal}>
        <div style={{ textAlign:'center', padding:'10px 0 20px' }}>
          <div style={{ fontSize:'40px', marginBottom:'12px' }}>✓</div>
          <div style={{ fontSize: 'var(--font-size-lg)', fontWeight:'600', marginBottom:'8px' }}>Ciclo creato con successo</div>
          <div style={{ color:'#555', fontSize: 'var(--font-size-sm)', marginBottom:'20px' }}>
            <strong>{result.ciclo.nome}</strong>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'8px', marginBottom:'20px' }}>
            {[
              { label:'Sedi copiate',    val: result.sedi_copiate },
              { label:'Slot copiati',    val: result.slot_copiati },
              { label:'Atleti copiati',  val: result.atleti_copiati },
            ].map(k => (
              <div key={k.label} style={{ background:'var(--bg-input,#1A1A1A)', borderRadius:'8px', padding:'10px' }}>
                <div style={{ fontSize: 'var(--font-size-xl)', fontWeight:'700' }}>{k.val}</div>
                <div style={{ fontSize: 'var(--font-size-xs)', color:'#555' }}>{k.label}</div>
              </div>
            ))}
          </div>
          {result.atleti_skippati > 0 && (
            <div style={{ background:'#F59E0B15', border:'1px solid #F59E0B30', borderRadius:'8px', padding:'10px 14px', fontSize: 'var(--font-size-xs)', color:'#854F0B', marginBottom:'16px', display:'flex', gap:'6px', alignItems:'center' }}>
              <AlertCircle size={14}/>
              {result.atleti_skippati} atleti saltati perché già presenti in altri slot del nuovo ciclo
            </div>
          )}
          <button style={s.btnPri} onClick={() => { onSuccess(result.ciclo); onClose(); }}>
            <Check size={14}/> Vai al nuovo ciclo
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={s.overlay}>
      <div style={s.modal}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
          <div>
            <div style={{ fontSize: 'var(--font-size-lg)', fontWeight:'700', fontFamily:"'Barlow Condensed'", letterSpacing:'1px', color:'#F4600C' }}>RINNOVA CICLO</div>
            <div style={{ fontSize: 'var(--font-size-xs)', color:'#555', marginTop:'2px' }}>Copia da: <strong>{cicloSorgente.nome}</strong></div>
          </div>
          <button style={s.iconBtn} onClick={onClose}><X size={14}/></button>
        </div>

        <div style={{ background:'var(--bg-input,#1A1A1A)', borderRadius:'8px', padding:'10px 14px', marginBottom:'14px', fontSize: 'var(--font-size-xs)', color:'#555' }}>
          Vengono copiati gli slot e solo gli atleti con <strong style={{ color:'#F4600C' }}>pacchetto annuale</strong>.
          Chi ha un pacchetto quadrimestrale non viene copiato e dovrà essere reinserito manualmente.
          {cicloSorgente.tipo === 'Q1' && <span style={{ color:'#22C55E', display:'block', marginTop:'4px' }}>Q1 → Q2: precompilato in automatico.</span>}
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr', gap:'10px', marginBottom:'10px' }}>
            <div><label style={s.label}>NOME CICLO *</label>
              <input style={s.inp} value={form.nome} onChange={e=>setForm(p=>({...p,nome:e.target.value}))}
                placeholder={`es. ${form.tipo === 'Q1' ? `Q1 ${form.anno_inizio}-${form.anno_inizio+1}` : form.tipo === 'Q2' ? `Q2 ${form.anno_inizio}-${form.anno_inizio+1}` : `Estivo ${form.anno_inizio}`}`} required/>
            </div>
            <div><label style={s.label}>TIPO</label>
              {cicloSorgente.tipo === 'Q1' ? (
                <div style={{ ...s.inp, color:'#22C55E', fontWeight:'700' }}>Quadrimestre 2 (obbligatorio)</div>
              ) : (
                <select style={s.inp} value={form.tipo} onChange={e=>{ const tipo=e.target.value; setForm(p=>({...p,tipo, quota_tesseramento: tipo === 'ESTIVO' ? 15 : (cicloSorgente.quota_tesseramento ?? 25)})); }}>
                  <option value="Q2">Quadrimestre 2</option>
                  <option value="ESTIVO">Estivo</option>
                </select>
              )}
            </div>
            <div><label style={s.label}>ANNO</label>
              <input type="number" style={s.inp} value={form.anno_inizio} onChange={e=>setForm(p=>({...p,anno_inizio:+e.target.value}))}/>
            </div>
            <div><label style={s.label}>QUOTA TESSERAMENTO €</label>
              <input type="number" step="0.01" min="0" style={s.inp} value={form.quota_tesseramento ?? ''} onChange={e=>setForm(p=>({...p,quota_tesseramento:e.target.value}))}/>
              <div style={{ fontSize:'var(--font-size-xs)', color:'#555', marginTop:'3px' }}>
                Stagione {form.stagione_tesseramento}/{String(form.stagione_tesseramento + 1).slice(-2)}: la pagano solo i nuovi
              </div>
            </div>
            <div><label style={s.label}>INIZIO ATTIVITÀ</label>
              <input type="date" style={s.inp} value={form.data_inizio} onChange={e=>setForm(p=>({...p,data_inizio:e.target.value}))}/>
            </div>
            <div><label style={s.label}>FINE ATTIVITÀ</label>
              <input type="date" style={s.inp} value={form.data_fine} onChange={e=>setForm(p=>({...p,data_fine:e.target.value}))}/>
            </div>
          </div>
          <div style={{ display:'flex', gap:'8px', justifyContent:'flex-end', marginTop:'4px' }}>
            <button type="button" style={s.btnSec} onClick={onClose}>Annulla</button>
            <button type="submit" style={s.btnPri} disabled={loading}>
              <Copy size={14}/> {loading ? 'Copiando...' : 'Crea nuovo ciclo'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const s = {
  overlay:  { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal:    { background:'var(--bg-card,#141414)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'14px', padding:'22px', width:'480px', maxWidth:'95vw' },
  btnPri:   { display:'flex', alignItems:'center', gap:'6px', background:'#F4600C', color:'#fff', border:'none', borderRadius:'8px', padding:'9px 16px', fontSize: 'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  btnSec:   { display:'flex', alignItems:'center', gap:'6px', background:'var(--bg-input,#1A1A1A)', color:'var(--text,#fff)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 14px', fontSize: 'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  iconBtn:  { background:'transparent', border:'none', color:'#555', cursor:'pointer', display:'inline-flex', alignItems:'center' },
  label:    { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'#555', display:'block', marginBottom:'4px' },
  inp:      { background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 12px', color:'var(--text,#fff)', fontSize: 'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
};
